import React from 'react'
import './CurveNotice.scss'

export function CurveNotice() {
  return (
    <p className="curve-notice">
      This UI is currently using the Curve v2 Metapool contracts. If you deposited funds and cannot
      see your previously LP tokens please visit crv.finance and find the v1 STABLEx CRV Pool.
    </p>
  )
}
